import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import fail from '../../assets/create-fail.png';
import success from '../../assets/create-success.png';
import headImg from '../../assets/icon-user.png';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .iconExpand': {
        transform: "rotate(180deg)",
        color: '#1A9AE7',
    },
    '& .iconExpandOpen': {
        transform: "rotate(0deg)",
        color: '#fff',
    },
    '& .extend': {
        backgroundColor: '#fff',
    },
    '& .bgW': {
        width: '100%',
        backgroundColor: '#fff',
    },
    '& .tab': {
        backgroundColor: '#1A9AE7',
        color: '#fff',
    },
    '& .tabs': {
        width: '1200px',
    },
    '& .tabSelect': {
        backgroundColor: '#FAFAFA',
        color: '#1A9AE7',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .userInfo': {
            '& .userImg': {
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                background: `url(${headImg}) no-repeat center top/cover`,
            },
            '& .userText': {
                marginLeft: '15px',
                fontSize: '16px',
                marginRight: '30px',
                '& .name': {
                    color: '#005F9B',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    marginBottom: '14px',
                },
                '& .business': {
                    fontWeight: 'bold',
                },
            },
        },
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '220px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .textDateField': {
        width: '170px',
        margin: '0 10px',
        backgroundColor: '#fff',
    },
    '& .tableWapper': {
        width: '100%',
        // height: '600px',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
            '& .cell': {
                width: '16%',
            },
        }
    },
    '& .textWapper': {
        borderLeft: '1px solid #979797',
        marginLeft: '30px',
        padding: '0 13px',
        maxWidth: '110px',
        '& .title': {
            color: '#979797',
            fontSize: '12px',
        },
        '& .time': {
            marginTop: '15px',
            fontSize: '18px',
        },
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .btn': {
        width: '186px',
    },
    '& .expandBtn': {
        width: '203px',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        color: '#1A9AE7',
        userSelect: 'none',
        cursor: 'pointer',
        padding: '5px 0',
    },
    '& .expandBtnOpen': {
        width: '203px',
        fontWeight: 'bold',
        backgroundColor: '#1A9AE7',
        color: '#fff',
        userSelect: 'none',
        cursor: 'pointer',
        padding: '5px 0',
    },
    '& .created': {
        width: '100%',
        height: '440px',
        '& .failIcon': {
            width: '108px',
            height: '108px',
            background: `url(${fail}) no-repeat center top/cover`,
        },
        '& .successIcon': {
            width: '108px',
            height: '108px',
            background: `url(${success}) no-repeat center top/cover`,
        },
        '& .title1': {
            fontSize: '20px',
            fontWeight: 'bold',
            marginTop: '17px',
        },
        '& .title2': {
            fontSize: '18px',
            '& .link': {
                color: '#009CEE',
                cursor: 'pointer',
                userSelect: 'none',
            },
            '& .link:hover': {
                textDecoration: 'underline',
            },
        },
    },
    '& .m-20': {
        margin: '0 20px',
    },
});